module.exports = __webpack_public_path__ + "img/doctor_male.b44f0eda.png";